<template>
	<!--div class="col-xl-3 col-md-4 col-sm-6 pl-1"-->
	<div class="ReCallsObjSmall-wrapper col-xs-6 mb-4" v-if="objData">
		<div class="ReCallsObjSmall">
			<card class="groupCard pt-2 h-100">
				<div class="groupTopBlock" >
					<div class="groupPhoto mb-3">
						<img v-if="objData.mainPhoto !='' || objData.mainPhoto !=null" :src="`${objData.mainPhoto}`" onerror="this.src='/img/flatsDefault.svg'; this.onerror=''"  alt="" @click="OpenObject(objData.id)"> 
						<img v-else src="/img/flatsDefault.svg" alt="" @click="OpenObject(objData.id)"> 
					</div>

					<!-- <a :href="'/data/ColdCall/id/'+objData.id" class="mt-3">{{objData.title}}</a> -->
					<router-link :to="'/data/ColdCall/id/'+objData.id" class="mt-3">{{objData.title}}</router-link>
				</div>

				<div class="groupBottBlock">
					<div class="row baseInfo mt-3">
						<p class="col-md-4 col-sm-12 px-0 ">{{$GVO.number_format(objData.price,0,'.',' ')}} ₽</p>
					</div>
					<div class="row">
						<p class="col-md-4 col-sm-12 px-0" v-if="objData.area!=null && objData.area!=''">S Общая {{objData.area}} м²</p>
						<p class="col-md-4 col-sm-12 px-0" v-if="objData.roomsSpace!=null && objData.roomsSpace!=''">S Комнат {{objData.roomsSpace}} м²</p>
						<p class="col-md-4 col-sm-12 px-0" v-if="objData.houseSpace!=null && objData.houseSpace!=''">S Дома {{objData.houseSpace}} м²</p>
						<p class="col-md-4 col-sm-12 px-0" v-if="objData.lotArea!=null && objData.lotArea!=''">S Участка {{objData.lotArea}} м²</p>
						<p class="col-md-4 col-sm-12 px-0" v-if="objData.kitchenSpace!=null && objData.kitchenSpace!=''">S Кухни {{objData.kitchenSpace}} м²</p>
					</div>
					<p class="">{{objData.region}}, {{objData.address}}</p>
					<div class="metro">						
						<div class="row flex-nowrap ml-0 mr-2 align-items-top" v-if="objData.metroName!=null  && objData.metroName!=''">
							<i class="tim-ic ic-metro text-primary mr-1"></i>
							<p>метро {{objData.metroName}}, </p>									
						</div> 								
						<div class="row ml-0 mr-2 align-items-center" v-if="objData.fromSubway!=null  && objData.fromSubway!='' && objData.fromSubway !='0.00'">
							<p>{{objData.fromSubway}} км</p>									
						</div> 								
					</div>
					<div class="mb-3">
						<p v-if="objData.salesAgentName!=null  || objData.salesAgentName!=''"><b>Агент: </b>{{objData.salesAgentName}}</p>
						<p><b>Объект на: </b> <a :href="objData.url" target="_blank" v-if="objData.url!='' || objData.url!=null">{{objData.source}}</a></p>
					</div>
					<div class="mb-3">
						<p><b>Сота: </b>ID {{objData.cellId}} {{objData.cellName}}</p>
						<p><b>Класс: </b>{{objData.houseCatLivingClassName}}</p>
					</div>
					<div v-if="objData.description!='' || objData.description!=null">
						<collapse>
							<collapse-item title="Описание">
								<div class="flatDescr mt-3">
									<p class="mr-1">{{objData.description}}</p>
								</div>
							</collapse-item>
						</collapse> 
					</div>
					<div class="mt-3">
						<p><b>Ответственный за прозвон: </b><router-link :to="`/data/staff/id/${objData.agentId}`">{{objData.agentName}}</router-link></p> 
						<!--p class="text-danger" v-if="objData.result_id === '3'" >Назначен новый звонок на 00.00.0000</!--p-->
					</div>
					<div class="callresult mt-4" style="">
						<collapse>
							<collapse-item title="Итог классификации">
								<div class="mt-3">
									<div class="d-flex">
										<p class="mr-2">Классификация: </p>
										<a href="#" v-if="objData.client_name"> {{objData.client_name}}</a>
										<p> {{objData.result_name}}</p>
									</div>
									<p>Примечание: {{objData.result_descr}}</p>
									<p>Кто классифициовал: <router-link :to="`/data/staff/id/${objData.agent_id}`">{{objData.agent_name}}</router-link></p>
								</div>
							</collapse-item>
						</collapse> 
					</div>
				</div>
				<!--pre>{{objData}}</pre-->
			</card>		
		</div>
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Carousel, CarouselItem, } from "element-ui";	

	export default {
		name: 'ReCallsObjSmall',
		components: {    
			Collapse,
			CollapseItem,
			[Carousel.name]: Carousel,
			[CarouselItem.name]: CarouselItem,        			
		},
		props: {
			objData: [Object,Array],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			
			// flatDescr: {
			// 	type: String,
			// 	default: 'Описание',
			// },
		},
		data () {
			return {
				ver: 1,
				bIsGroupfloor: true,
				masFloorGrouping:[],
			}
		},
		computed: {

		},
		methods: {
			OpenObject: function(obj_id){
				this.$router.push({path: '/data/ColdCall/id/'+obj_id});		
				// this.$router.push({path: '/data/ColdCall/id/'+obj_id}, {query: {currentTab:this.currentTab}});	
				// console.log(this.currentTab);
				// console.log(localStorage);
					
			},
		},
	}
</script>
<style scoped>
.ReCallsObjSmall {width: 500px;}
.ReCallsObjSmall-wrapper  {display: flex; flex-wrap: wrap; margin-right: 30px;}
.ReCallsObjSmall >>> .card-body {padding: 0px 5px 10px 5px;}
.ReCallsObjSmall >>> .row {margin: 0px 0px 5px 0px;}
.ReCallsObjSmall:not(:last-child) {margin-right: 15px;}
.ReCallsObjSmall >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}
.groupCard {border: 1px solid #9e77f3; padding: 0px 0px 0px 10px; height: -webkit-fill-available;}
.groupBottBlock {padding:0px 10px 0px 0px;}
.groupTopBlock {border-bottom: 1px solid #01b0e0; padding: 20px 0px;}
.groupBottBlock {padding-top: 10px;}
.baseInfo p{font-size: 18px; color: #00bf9a; font-weight: bold;}
.groupPhoto {display: flex; width: 100%; height: 200px; cursor: pointer;}
.groupPhoto img {width: 100%; height: 100%; margin: 0 auto; object-fit: contain;}
.groupfloor p:not(:last-child) {margin-right: 10px;}
.groupfloor {display: flex; flex-wrap: wrap; border-bottom: 1px solid rgb(1, 176, 224, 0.4);;}
.groupfloor p {color: unset;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.objectPass {display: flex; justify-content: flex-start; flex-wrap: wrap;}
.objectPass  p:not(:first-child) {margin-left: 10px; padding-left: 5px;position: relative;}
.objectPass p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: -3px;
	top: 40%;
} 
.objectPass .blue-dot {margin-right: 7px; padding-right: 12px; position: relative;}
.objectPass .blue-dot:not(:last-child)::after {
	content: '';
	position: absolute;
	margin-left: 7px;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #01b0e0;
	top: 30%;
	right: 2px;
}
.objectPass-row {display: flex; flex-wrap: wrap;}
.objectDev {display: flex; justify-content: space-between; padding-right: 0px;}
.ReCallsObjSmall .money, .ReCallsObjSmall .floor {margin-bottom: 2px;}

/*===media===============================*/
@media (max-width: 768px) {	
	.ReCallsObjSmall {width: 100%; margin-bottom: 15px;}
	.ReCallsObjSmall-wrapper {flex-direction: column; width: 100%; margin-right: 0px;}
	.groupCard {padding:0px 0px 7px;}
	.groupfloor {font-size: 12px;}
	.groupBottBlock {padding: 0px 10px 0px 10px;}
}


</style>
